<toaster-container></toaster-container>
<h2 class="title">Log In</h2>
<form (ngSubmit)="login()" [formGroup]="loginForm">
  <mat-form-field>
    <input matInput type="email" placeholder="Email address" formControlName="email" (blur)="getToken()" />
    <ng-container *ngIf="email.invalid && (email.dirty || email.touched)">
      <mat-error>
        {{ email.errors.required ? 'Email is a required field' : '' }}
        {{ !email.errors.required && email.errors.email ? 'Not a valid email address' : '' }}
      </mat-error>
    </ng-container>
  </mat-form-field>

  <mat-form-field>
    <input matInput type="password" placeholder="Password" formControlName="password" />
    <ng-container *ngIf="password.invalid && (password.dirty || password.touched)">
      <mat-error *ngIf="password.errors.required">
        Password is a required field
      </mat-error>
    </ng-container>
  </mat-form-field>

  <button mat-raised-button [disabled]="submitted" color="primary" [class.btn-pulse]="submitted">
    Sign In
  </button>
</form>
<br />

<p>Forgot your password? Click <a [routerLink]="['/auth', 'forgot-password']"
                                                                class="auth-link">here</a></p>
